const transports = [
  {
    title: "Célébrations et Evènements",
    slug: "célébrations",
    image:
      "/celebration.jpeg",
    description:
      "De l'idée à la célébration, une organisation sans fausse note.",
    details: `
        Vos moments les plus précieux méritent une organisation parfaite. Qu'il s'agisse de l'émotion d'un mariage, de la joie d'un anniversaire ou de l'importance d'un séminaire d'entreprise, nous transformons votre vision en une réalité sans fausse note. Nous prenons en charge chaque détail, de la planification à la coordination le jour J, pour que vous puissiez vous concentrer pleinement sur vos invités et profiter de l'instant.
    `,
  },
  {
    title: "Production de spectacles",
    slug: "production",
    image:
      "/production.jpeg",
    description:
      "Nous gérons les coulisses, vous brillez sur scène.",
    details: `
        Faire vibrer une scène, c'est bien plus qu'une simple performance : c'est un événement qui se prépare dans les moindres détails. Nous sommes les professionnels derrière le rideau, dédiés à l'organisation de concerts, de festivals et de showcases inoubliables. De la logistique à la régie technique, nous gérons les coulisses pour vous permettre de briller sur scène et d'offrir une expérience mémorable à votre public.
    `,
  },
];

export default transports;
